export const GET_ALL_IMAGES = 'GET_ALL_IMAGES';


